<template>
  <router-link
    class="xrow"
    @click="$emit('setSelectedApplication', application)"
    :to="`/${pageName.toLowerCase()}/${application.referenceId}`"
  >
    <div class="xcell xname">
      <div class="xusericon" data-size="small">
        <div class="xusericon-picture">
          {{ decodeHTMLEncodedStr(application.initials) || "" }}
        </div>
        <!-- <div class="xusericon-gender" data-xgender=""></div> -->
      </div>
      <div class="xpage-openapps-box-name">
        <h4
          :title="decodeHTMLEncodedStr(application.name) || 'No Name'"
          v-html="decodeHTMLEncodedStr(application.name) || 'No Name'"
        ></h4>
        <h5 :title="application.lenderName || application.defaultLenderName">
          {{ application.lenderName || application.defaultLenderName }}
        </h5>
        <h6 v-html="application.searchNotification"></h6>
      </div>
    </div>
    <!-- Legacy Code; displays the status for each tab -->
    <!-- <div class="xcell xstatuses" style="display: none">
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">Income</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-money"></i>
                    </div>
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">Identity</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-adult"></i>
                    </div>
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">Membership</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-bank"></i>
                    </div>
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">E-Sign</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-pencil-alt"></i>
                    </div>
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">Credit</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-credit-card"></i>
                    </div>
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">E-Sign</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-pencil-alt"></i>
                    </div>
                    <div class="xicon-on-tile xtooltip">
                      <span class="xtooltiptext">Credit</span>
                      <div class="xicon-status icon-ok-circle"></div>
                      <i class="icon-credit-card"></i>
                    </div>
                  </div> -->
    <div class="xcell xsearchtext">
      <h6 v-if="application.nameCoApplicant" v-html="application.nameCoApplicant"></h6>
    </div>
    <div class="xcell xprogress">
      <div class="xpage-openapps-box-bar">
        <div class="xpage-openapps-box-bar-inner width-100"></div>
      </div>
      <h4>Progress</h4>
    </div>
    <div class="xcell xdate">
      <h3>
        {{ application.createdAtFormatted }}
      </h3>
      <span v-if="showCreatedDate" style="color: red">{{
        application.createdAtUtc
      }}</span>
    </div>
    <!-- Legacy Code; usefulness undetermined -->
    <!-- <div class="xcell xamount" style="display: none">
                    <h6>${{ application.amount }}</h6>
                  </div>
                  <div class="xcell xowner" style="display: none">
                    <div
                      class="xusericon xtooltip"
                      data-size="tiny"
                      style="display: inline-block; vertical-align: middle">
                      <span class="xtooltiptext">Jennifer Pao</span>
                      <div class="xusericon-picture" style="color: white">
                        JP
                      </div>
                    </div>
                    <i class="icon-down-open-big" style="font-size: 10px"></i>
                  </div> -->
  </router-link>
</template>

<script setup lang="ts">
import useFunctions from "@/use/functions1";
import { useDebugDateKey } from "@/composables/useDebugDateKey";

const { decodeHTMLEncodedStr } = useFunctions();
const { showCreatedDate } = useDebugDateKey();

const props = defineProps<{
  application: any;
  pageName: string;
  layout: "boxes" | "table";
}>();

const emit = defineEmits<{
  (event: "setSelectedApplication", application: any): void;
}>();
</script>
